var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('header',{staticClass:"app__header"},[_c('app-nav')],1),_c('main',{staticClass:"app__main"},[_c('div',{staticClass:"app__main-container"},[_c('router-view',{staticClass:"app__main-inner"})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }